import { render, staticRenderFns } from "./chateau-pavie.vue?vue&type=template&id=65555e22&scoped=true"
import script from "./chateau-pavie.vue?vue&type=script&lang=js"
export * from "./chateau-pavie.vue?vue&type=script&lang=js"
import style0 from "./chateau-pavie.vue?vue&type=style&index=0&id=65555e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65555e22",
  null
  
)

export default component.exports